import React, { useState, useContext } from "react";
import MultiStepFormContext from "./../MultiStepForm/MultiStepFormContext";
import privateAxios from "../../utils/axiosPrivate";
import { showToast } from "../../utils/utils";
import "./allaccountsteps.scss";
import {
  FORCE_APPLICATION_PROCESS,
  showToastType
} from "../../utils/constants/appConstants";
import {
  checklistQuestion,
  commonErrMsg,
  directDebit,
  onboardingStepData,
  pagination
} from "../../locales/en";
import {
  getBillingRequestFlowsUrl,
  getUserManagementsystemSettingsUrl
} from "../../utils/constants/apiEndPoints";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { INVOICE } from "../../route/paths";

const DirectDebit = () => {
  const { prev, isConnectedSoftware, annatureStatusData } =
    useContext(MultiStepFormContext);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const { profile: loggedUserData } = useSelector(
    (state) => state.userManagement
  );
  const authUser = loggedUserData;
  // for go cardless
  const createGoCardlessPost = async () => {
    try {
      const userId = authUser?.id;
      if (!userId) {
        throw new Error(directDebit?.errMsg.item1);
      }
      const goCardLessData = {
        id: userId
      };
      const response = await privateAxios.post(
        getBillingRequestFlowsUrl,
        goCardLessData
      );
      return response.data.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.errors?.join(", ") ||
        error.response?.data?.message ||
        error.message ||
        commonErrMsg?.item4;
      showToast(errorMessage, showToastType?.error);
      return null;
    }
  };

  // The mandate is in place, so there is nothing left to authorise: clear the
  // forced application process and move the customer on.
  const finishWithExistingMandate = async () => {
    try {
      setLoading(true);
      const userId = authUser?.id;
      if (userId) {
        const key = FORCE_APPLICATION_PROCESS;
        const value = "false";
        await privateAxios.patch(
          `${getUserManagementsystemSettingsUrl(userId)}?key=${encodeURIComponent(key)}&value=${encodeURIComponent(value)}`
        );
      }
    } catch {
      // handle catch here
    } finally {
      setLoading(false);
    }
    navigate(INVOICE);
  };

  const handleSubmit = async () => {
    const isMandateIdPresent = authUser?.userAccountMeta?.mandateId;

    if (isMandateIdPresent) {
      await finishWithExistingMandate();
      return;
    }

    try {
      setLoading(true);

      const flow = await createGoCardlessPost();

      // An account that already holds a mandate is answered with the mandate
      // rather than a new billing request. The account meta was empty here, so
      // onboarding-service has just written the mandate ID back to it.
      if (flow?.mandateId) {
        await finishWithExistingMandate();
        return;
      }

      // Check if both operations were successful
      if (flow?.authorisationUrl) {
        window.location.href = flow.authorisationUrl;
      } else {
        showToast(directDebit?.errMsg.item2, showToastType?.error);
      }
    } catch {
      showToast(directDebit?.errMsg.item3, showToastType?.error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="spinner-wrap bg-light">
        <div className="spinner-border custom-spinner-color" />
      </div>
    );
  }

  const unconnectedStepTitle = annatureStatusData?.status
    ? onboardingStepData?.annatureConnected?.step6
    : onboardingStepData?.withoutConnected?.step5;
  const stepTitle = isConnectedSoftware
    ? directDebit?.step6Title
    : unconnectedStepTitle;

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-md-8 offset-md-2">
            <div className="step-wrap">
              <div className="step-title">
                <h3>{stepTitle}</h3>
              </div>
              <div className="step-content">
                <div className="aplyid-section">
                  <p>{directDebit?.lastStep}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="step-btn-group d-flex justify-content-center align-items-center mt-5 mb-5 flex-wrap">
        <div className="prev-btn p-1">
          <button type="button" className="btn btn-primary" onClick={prev}>
            {pagination.previous}
          </button>
        </div>
        <div className="next-btn p-1">
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleSubmit}
          >
            {checklistQuestion?.listData.submitBtn}
          </button>
        </div>
      </div>
    </>
  );
};

export default DirectDebit;
